import React from 'react';
import { PASO_ACTIVIDAD, PASO_OPORTUNIDAD_COMPRA, PASO_OPORTUNIDAD_VENTA, pasoCompletado } from '../../api/feriasApi';
import type { PasoBandeja } from '../../api/feriasApi';
import { FctIcono } from '../../fct/react';
import type { FctNombreIcono } from '../../fct/react';

/** Lo que un caso puede generar desde «Acciones», con el paso del avance que lo registra (M6 §4). */
const GENERABLES: { idPaso: number; etiqueta: string; icono: FctNombreIcono }[] = [
  { idPaso: PASO_ACTIVIDAD, etiqueta: 'Actividad generada', icono: 'calendario' },
  { idPaso: PASO_OPORTUNIDAD_VENTA, etiqueta: 'Oportunidad de venta generada', icono: 'importe' },
  { idPaso: PASO_OPORTUNIDAD_COMPRA, etiqueta: 'Oportunidad de compra generada', icono: 'cartera' },
];

/**
 * Los iconos de lo que el caso ya generó (actividad, oportunidad de venta, oportunidad de compra), uno por
 * paso completado, cada uno con su texto accesible y su título; nada si no generó nada.
 */
export const Generado: React.FC<{ avance: PasoBandeja[] }> = ({ avance }) => {
  const generados = GENERABLES.filter((g) => pasoCompletado(avance, g.idPaso));
  if (generados.length === 0) {
    return null;
  }
  return (
    <span className="ferias-generado">
      {generados.map((g) => (
        <span key={g.idPaso} title={g.etiqueta}>
          <FctIcono nombre={g.icono} titulo={g.etiqueta} />
        </span>
      ))}
    </span>
  );
};
